import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 100%;
    gap: 30px;
    padding-bottom: 50px;
`;

export const Container = styled.div`
    padding-left: ${({ theme }) => `${theme?.pageTemplate?.paddingLeftRight?.xs}`};
    padding-right: ${({ theme }) => `${theme?.pageTemplate?.paddingLeftRight?.xs}`};

    ${media.mdmin`
        padding-left: ${({ theme }) => `${theme?.pageTemplate?.paddingLeftRight?.md}`};
        padding-right: ${({ theme }) => `${theme?.pageTemplate?.paddingLeftRight?.md}`};
    `}
    ${media.lgmin`
        padding-left: ${({ theme }) => `${theme?.pageTemplate?.paddingLeftRight?.lg}`};
        padding-right: ${({ theme }) => `${theme?.pageTemplate?.paddingLeftRight?.lg}`};
    `}

`;

const Row = styled.div`
    display: grid;
    row-gap: 30px;
    column-gap: 3%;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-template-areas: 'player'
                         'story'
                         'info';

    ${media.mdmin`
        grid-template-columns: 1fr 2fr;
        grid-template-areas: 'player player'
                             'story info';
    `}

    ${media.lgmin`
        grid-template-columns: 16fr 7fr 10fr;
        grid-template-areas: 'player story info';
    `}

    ${media.xlmin`
        grid-template-columns: 16fr 7fr 8fr;
    `}
`;

const PlayerColumn = styled.div`
    grid-area: player;
`;

const GameInfo = styled.div`
    grid-area: info;
    align-self: start;
    display: grid;
    align-content: center;
    grid-template-columns: 100%;
    gap: 16px;
    max-width: 360px;
    margin: 0 auto;
`;

const Story = styled.div`
    grid-area: story;
`;

const Template = (props) => {

    const {
        hero,
        headline,
        player,
        story,
        linescore,
        decisions,
        carousels,
        innings,
        notification,
    } = props;

    return (
        <Wrapper>
            {notification}
            {hero}
            <Container>
                {headline}
                <Row>
                    <PlayerColumn>
                        {player}
                    </PlayerColumn>
                    <Story>
                        {story}
                    </Story>
                    <GameInfo>
                        {linescore}
                        {decisions}
                    </GameInfo>
                </Row>
            </Container>
            {carousels}
            <Container>
                {innings}
            </Container>
        </Wrapper>
    );

};

Template.propTypes = {
    hero: PropTypes.element.isRequired,
    headline: PropTypes.element.isRequired,
    player: PropTypes.element.isRequired,
    linescore: PropTypes.element.isRequired,
    decisions: PropTypes.element.isRequired,
    carousels: PropTypes.element.isRequired,
    innings: PropTypes.element.isRequired,
    notification: PropTypes.element.isRequired,
};

export default Template;
